import { WebStorageDecorator } from './webStorage';
import { STORAGE } from '../enums/storage';
export function LocalStorage(webSKey, defaultValue) {
    return function (targetedClass, raw) {
        WebStorageDecorator(webSKey, STORAGE.local, targetedClass, raw, defaultValue);
    };
}
//# sourceMappingURL=localStorage.js.map


//////////////////
// WEBPACK FOOTER
// ./node_modules/ng2-webstorage/dist/decorators/localStorage.js
// module id = 84
// module chunks = 0